import axios from "axios";
import authService from "./authService";

const BASE_URL = process.env.REACT_APP_API_URL || "https://scannerspro.duckdns.org/api";

// Usando /api/assinaturas
const API_URL = `${BASE_URL}/assinaturas`;

// Criar assinatura (gera um link de checkout do Mercado Pago)
const createSubscription = async (tipoPlano) => {
  const token = authService.getToken();

  const response = await axios.post(
    `${API_URL}/criar-assinatura`,
    { tipoPlano },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data; // contém o init_point do Mercado Pago
};

// Validar acesso ao painel
const validateAccess = async () => {
  const token = authService.getToken();

  const response = await axios.get(
    `${BASE_URL}/painel-gestao`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

const subscriptionService = {
  createSubscription,
  validateAccess,
};

export default subscriptionService;
